import React from "react";
// import './mathsubject.css';
import UpdateMyInfo from "../components/UpdateMyInfo";
import ForStudentMenu from "../components/ForStudentMenu";

const StudentUpdateMyInfo = () => {
       return (
              <div className="App-full-row-container">
                     <div className="left-menu-box-1" style={{fontWeight:"bolder", color:"orange" ,marginTop:"10px", marginBottom:"1px", marginLeft:"30px"}}>
                            <ForStudentMenu />
                     </div>
                     <div className="content-box-1">
                            <UpdateMyInfo />
                     </div>
              </div>
       )
}

export default StudentUpdateMyInfo;